import IncomeCurvesPage from "@app/pages/income-curves/income-curves-page";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/income-curves")({
  head: () => pageHead("Income curves"),
  component: IncomeCurvesPage,
});
